import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import { SnackbarOpen } from '#app/Action/SnackbarAction';
import { dispatch } from '#app/App';
import TextFieldComponent from '#app/Component/TextFieldComponent';
import ApiHandler from '#app/Handler/ApiHandler';
import { Form, initFormHandler } from '#app/Handler/FormHandler';
import Modal from '#app/View/ClientService/OrderClientLitige/components/Modal';

type Props = {
  reload: () => void;
  onClose: () => void;
};

const CancelModal: React.FC<Props> = ({ onClose, reload }) => {
  const params = useParams<{ uuid: string }>();
  const uuid = params.uuid as string;
  const [loading, setLoading] = useState<boolean>(false);

  const [form, setForm] = useState<Form>({
    commentClosing: {
      name: 'commentClosing',
      label: 'Commentaire litige envoyé au client',
      textHelper: 'Saisissez un commentaire litige envoyé au client.',
      type: 'text',
    },
  });
  const handler = initFormHandler(form, setForm);

  const handleSubmit = () => {
    setLoading(true);

    const data = handler.getData();
    ApiHandler.post(
      {
        route: 'api_client_service_order_client_litige_close',
        params: { uuid },
        data: {
          commentClosing: data.commentClosing,
        },
      },
      (response) => {
        if (response.status === 200) {
          dispatch(
            SnackbarOpen({
              text: 'Litige clôturé avec succès.',
              variant: 'success',
            }),
          );
          reload();
        } else {
          dispatch(
            SnackbarOpen({
              text: response?.error?.message || "Une erreur inattendue s'est produite.",
              variant: 'error',
            }),
          );
        }
        setLoading(false);
        onClose();
      },
    );
  };

  return (
    <Modal title="Cloturer le litige" onClose={onClose} onSubmit={handleSubmit} loading={loading}>
      <TextFieldComponent id="commentClosing" handler={handler} multiline={true} />
    </Modal>
  );
};

export default CancelModal;
